module.exports = __webpack_public_path__ + "static/media/video.39b19c66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyCentral/video.jpg
// module id = 278
// module chunks = 0